import { PopoverContent as AkPopoverContent, type PopoverContentProps } from '@atlaskit/spotlight';

import { wrapToggleableComponentForChoreographer } from '../utils';

export const PopoverContent = wrapToggleableComponentForChoreographer<PopoverContentProps>(
	AkPopoverContent,
	'isVisible',
);
